import React, {useEffect, useMemo, useRef, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import {
  entityFilter,
  getFilteredAndPaginatedEntities,
  headerSortingClasses,
  sortCaret
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import {useAnnotationTypeUIContext} from "../AnnotationTypeUIContext";
import * as actions from "../../_redux/AnnotationTypeAction";
import {SearchText} from "../../../../../shared/components/SearchText";
import * as moment from "moment";
import BlockUi from "react-block-ui";
import {BoootstrapTable} from "../../../../../shared/components/BoootstrapTable";

export function AnnotationTypeTable() {
  const annotationTypeUIContext = useAnnotationTypeUIContext();
  const annotationTypeUIProps = useMemo(() => annotationTypeUIContext, [
    annotationTypeUIContext
  ]);

  const columns = [
    {
      dataField: "#",
      text: "Index",
      formatter: (cell, row, rowIndex) => {
        return <span>{(page - 1) * size + (rowIndex + 1)}</span>;
      }
    },
    {
      dataField: "annotation_type_name",
      text: "Annotation Type Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        minWidth: "165px"
      }
    },
    {
      dataField: "annotation_type_name_description",
      text: "Annotation Type Description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "created_date",
      text: "Created Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (_, row) =>
        moment
          .utc(row?.created_date)
          .local()
            .format("DD MMMM YYYY, HH:mm:ss"),
      style: {
        minWidth: 180
      }
    },
    {
      dataField: "updated_date",
      text: "Updated Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (_, row) =>
        moment
          .utc(row?.updated_date)
          .local()
            .format("DD MMMM YYYY, HH:mm:ss"),
      style: {
        minWidth: 180
      }
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        openChangeStatusDialog: annotationTypeUIProps.openChangeStatusDialog
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditAnnotationTypeDialog:
          annotationTypeUIProps.openEditAnnotationTypeDialog
      },
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Getting current state of annotation types from store (Redux)
  const { currentState } = useSelector(
    state => ({ currentState: state?.annotationType }),
    shallowEqual
  );

  const { entities, listLoading, totalAnnotation,page,size } = currentState;
  const [filterEntities, setFilterEntities] = useState(entities);
    const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const searchInput = useRef("");
  let currentItems = getFilteredAndPaginatedEntities(
    filterEntities || entities,
    annotationTypeUIProps.queryParams
  );

  //Filter data for annotation type
  const filterAnnotationType = e => {
    // const searchStr = e?.target?.value || searchInput.current.value;
    const keys = [
      "annotation_type_name",
      "annotation_type_name_description",
      "created_date",
      "updated_date"
    ];
    currentItems = entityFilter(
      entities || filterEntities,
      null,
      keys,
      annotationTypeUIProps.queryParams,
      setFilterEntities
    );
  };

  //State Change Handlers
  const dispatch = useDispatch();
  useEffect(() => {
    setLoader(true);
      dispatch(actions.fetchAnnotationTypes(1, 10, search));
  setTimeout(() => {
      setLoader(false);
    }, 50);
  }, [ dispatch]);

  useEffect(() => {
    filterAnnotationType();
    // eslint-disable-next-line
  }, [entities]);

  const onPageChange = (page, sizePerPage) => {
    dispatch(actions.fetchAnnotationTypes(page, sizePerPage, search))
  };

  const onSizePerPageChange = ( sizePerPage) => {
    dispatch(actions.fetchAnnotationTypes(1,sizePerPage, search))
  };
  const onKeyPressHandler = e => {
    if (e.key === "Enter") {
      dispatch(actions.fetchAnnotationTypes(1, size, search))
    }
  };

  const onChangeSearch = e => {
    const searchStr = e?.target?.value || searchInput.current.value;
    setSearch(searchStr);
  };
  return (
    <>
      <div>
        <div className=" mb-5 pagination-tab " />
        <BlockUi tag="div" blocking={loader} color="#147b82">
          <SearchText
            reference={searchInput}
            onChangeHandler={onChangeSearch}
            onKeyDown={onKeyPressHandler}
            searchField={"on ANNOTATION TYPE NAME"}

          />
          {currentItems && currentItems.length > 0 ? (
            <BoootstrapTable
              sizePerPageList={[
                { text: "10", value: 10 },
                { text: "5", value: 5 },
                { text: "3", value: 3 }
              ]}
              hideSizePerPage={false}
              showTotal={true}
              alwaysShowAllBtns={true}
              hidePageListOnlyOnePage={true}
              columns={columns}
              data={currentItems}
              sizePerPage={size}
              page={page}
              totalSize={totalAnnotation}
              onTableChange={onPageChange}
              sizePerPageChange={onSizePerPageChange}
            />
          ) : (
            <h3 className={"table-center"}>No Data Available</h3>
          )}
        </BlockUi>
      </div>
    </>
  );
}
